import { redirect } from 'redux-first-router';
import _ from 'lodash';

import config from './lib/config';
import { settings } from './lib/settings';

const HARDCODED_MENU_ITEMS = [
  'user/myaccount',
];

const routes = {
  LOGIN: {
    requiresAuthentication: false,
    path: '/(login)?',
    fetchPreRender: () => Promise.resolve(),
  },
  PAGE: {
    requiresAuthentication: true,
    path: '/:orgId/:toplevel/:secondlevel?/:id1?/:id2?/:id3?',
    fetchPreRender: (dispatch, getState) => {
      const state = getState();

      const payload = {
        ...state.location.payload,
      };

      let toplevel = payload.toplevel;
      let secondlevel = payload.secondlevel;
      const orgId = payload.orgId;
      const menuItems = config.menuItems || [];
      const toplevels = [];
      const secondlevels = [];

      _.each(menuItems, (t) => {
        toplevels.push(t.type);
        _.each(t.children || [], (c) => {
          secondlevels.push(c.type);
        });
      });

      const user = settings.get('user', {});
      const userOrgs = settings.get('user.orgs', []);
      const orgIds = _.map(userOrgs, o => o.id);
      if (!orgId || orgId === 'default') {
        if (_.isString(user.defaultOrg)) {
          payload.orgId = user.defaultOrg;
        } else if (orgIds && orgIds.length) {
          payload.orgId = orgIds[0];
        }
      }

      if (HARDCODED_MENU_ITEMS.includes(`${toplevel}${secondlevel ? `/${secondlevel}` : ''}`.toLowerCase())) {
        return Promise.resolve();
      }

      if (!toplevels.includes(toplevel.toLowerCase())) {
        dispatch(redirect({ type: '@@redux-first-router/NOT_FOUND' }));
      } else if (secondlevel && !secondlevels.includes(secondlevel.toLowerCase())) {
        dispatch(redirect({ type: '@@redux-first-router/NOT_FOUND' }));
      } else if (!secondlevel) {
        if (_.isString(user.defaultRoute)) {
          const split = user.defaultRoute.split('/');
          toplevel = split[0];
          secondlevel = split[1] || null;
          dispatch(redirect({ type: 'PAGE', payload: { toplevel, secondlevel } }));
        } else {
          const orgRole = settings.get(`user.orgRoles.${payload.orgId}`, -1);
          secondlevel = orgRole.dashboard || 'analyst';
          window.setTimeout(dispatch(redirect({
            type: 'PAGE',
            payload: { ...payload, toplevel, secondlevel },
          })), 200); // @xxx throttling this in case of accidental logic infinite loops
        }
      }

      return Promise.resolve();
    },
  },
  CUSTOMER_REDIRECT: {
    requiresAuthentication: true,
    path: '/:orgId',
    fetchPreRender: (dispatch, getState) => {
      const state = getState();

      const payload = {
        ...state.location.payload,
      };

      let toplevel = payload.toplevel || 'dashboard';
      let secondlevel = payload.secondlevel;

      const user = settings.get('user');
      if (_.isString(user.defaultRoute)) {
        const split = user.defaultRoute.split('/');
        toplevel = split[0];
        secondlevel = split[1] || null;
        dispatch(redirect({ type: 'PAGE', payload: { toplevel, secondlevel } }));
      } else if (user.role) {
        secondlevel = user.role;
        dispatch(redirect({ type: 'PAGE', payload: { ...payload, toplevel, secondlevel } }));
      }
      return Promise.resolve();
    },
  },
};

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js